var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-codemirror",class:{ merge: _vm.merge }},[(_vm.merge)?_c('div',{ref:"mergeview"}):_c('textarea',{ref:"textarea"})])
}
var staticRenderFns = []

export { render, staticRenderFns }